<template>

    <div class="video">
        <video poster="@/img/video-cover.jpg" muted playsinline autoplay="autoplay" loop="loop">
            <source v-if="isIE()" src="@/img/video-bg.mp4" type="video/mp4">
            <source v-else src="@/img/video-bg__265.mp4" type="video/mp4">
            <source src="@/img/video-bg.webm" type="video/webm">
        </video>
        <div class="video-overlay"></div>
    </div>
</template>

<script>

    export default {
        name: 'VideoIndex',

       methods: {

            isIE () {
                return this.$browserDetect.isIE;
           }
       }
    }

</script>